export default {
      id: "login-personal-usage",
      viewBox: "0 0 96 96",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#login-personal",
      toString: function () {
        return this.url;
      }
    }